/**
 * Resolves after the UI has had one task turn plus one animation frame to
 * react to a state change or navigation. Voice handlers await this before
 * reading page state that a just-issued action is expected to have changed.
 */
export const waitForUiSurfaceToSettle = () =>
    new Promise<void>(resolve => {
        window.setTimeout(() => {
            window.requestAnimationFrame(() => resolve());
        }, 0);
    });

/**
 * Polls `predicate` between settle cycles until it holds or `timeoutMs`
 * elapses. Returns whether the predicate held.
 */
export const waitForUiCondition = async (
    predicate: () => boolean,
    timeoutMs = 8_000
): Promise<boolean> => {
    const deadline = Date.now() + timeoutMs;
    while (!predicate()) {
        if (Date.now() >= deadline) {
            return false;
        }
        await waitForUiSurfaceToSettle();
    }
    return true;
};
